__turbopack_context__.v({
  "Timeout": "SectionHeader-module__T5s65a__Timeout",
  "TimeoutItems": "SectionHeader-module__T5s65a__TimeoutItems",
  "active": "SectionHeader-module__T5s65a__active",
  "arrow": "SectionHeader-module__T5s65a__arrow",
  "button": "SectionHeader-module__T5s65a__button",
  "changer": "SectionHeader-module__T5s65a__changer",
  "contents": "SectionHeader-module__T5s65a__contents",
  "filter": "SectionHeader-module__T5s65a__filter",
  "filterContainer": "SectionHeader-module__T5s65a__filterContainer",
  "filterItem": "SectionHeader-module__T5s65a__filterItem",
  "filterItems": "SectionHeader-module__T5s65a__filterItems",
  "icon": "SectionHeader-module__T5s65a__icon",
  "last": "SectionHeader-module__T5s65a__last",
  "left": "SectionHeader-module__T5s65a__left",
  "middle": "SectionHeader-module__T5s65a__middle",
  "name": "SectionHeader-module__T5s65a__name",
  "right": "SectionHeader-module__T5s65a__right",
  "sectionHeader": "SectionHeader-module__T5s65a__sectionHeader",
  "text": "SectionHeader-module__T5s65a__text",
  "timeout": "SectionHeader-module__T5s65a__timeout",
  "title": "SectionHeader-module__T5s65a__title",
});
